export const MOBILE_BREAKPOINT = 640
export const HEADER_MOBILE_BREAKPOINT = 859 // same as --max-header-change-layout

export const DEFAULT_AUTOPLAY_DELAY = 5000

export const PURCHASE_TYPES = {
  ONE_TIME: 'one-time',
  SUBSCRIPTION: 'subscription',
}
